<app-ship-details
  *ngIf="ship"
  [shipData]="ship"
  [shipResultArray]="shipResultArray"
  (newShipSelectedEmitter)="onShipChange($event)"
>
</app-ship-details>

<div class="row" style="padding-top: 20px;" *ngIf="shipMerchantArray">
  <div class="col-md-5">
    <div class="card-nc" style="background-color: #ffffff;">
      <div class="row">
        <div class="col-md-4">
          <span class="labelCommon"
            >&nbsp;&nbsp;Total Enrolled<br />&nbsp;&nbsp;Merchants</span
          >
        </div>
        <div class="col-md-8 pull-right text-right" style="padding-top: 10px;">
          <span class="searchResultDropdown"
            >{{ shipMerchantArray.length }} Merchants&nbsp;&nbsp;</span
          >
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-7">
    <div class="card-nc" style="background-color: #ffffff;">
      <span class="pull-right save-panel">
        <button
          type="submit"
          *ngIf="hasEntitlement('SHIPS_MERCHANTS_UPDATE')"
          [disabled]="save_m_btn"
          (click)="updateMerchantSFA()"
          class="btn btn-nc"
          style="height: 41px;"
        >
          SAVE <i [class]="save_m_btn_spinner"></i>
        </button>
      </span>

      <form name="merchantDetailForm" [formGroup]="merchantDetailForm">
        <div class="row">
          <div class="col-md-3">
            <span class="labelCommon"
              >&nbsp;&nbsp;Postal Merchant <br />&nbsp;&nbsp;SFA Number
            </span>
          </div>
          <div
            class="col-md-4"
            style="padding-top: 5px;"
            *ngIf="hasEntitlement('SHIPS_MERCHANTS_UPDATE')"
          >
            <input
              type="text"
              class="textboxlight"
              formControlName="sfaNumber"
              id="sfaNum"
            />
            <span
              *ngIf="
                !merchantDetailForm.get('sfaNumber').valid &&
                merchantDetailForm.get('sfaNumber').touched
              "
              class="help-block has-error validationMessage"
            >
              <span
                *ngIf="
                  merchantDetailForm.get('sfaNumber').errors['invalidSFANumber']
                "
              >
                should be a number
              </span>
              <span
                *ngIf="merchantDetailForm.get('sfaNumber').errors['required']"
              >
                Required
              </span>
            </span>
          </div>
          <div
            class="col-md-4 staticText1"
            style="padding-top: 5px;"
            *ngIf="!hasEntitlement('SHIPS_MERCHANTS_UPDATE')"
          >
            {{ ship.sfaNum }}
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div
  class="card card-nc"
  *ngIf="hasEntitlement('SHIPS_MERCHANTS_INFO') && shipMerchantArray"
>
  <div class="card-heading">
    <i class="fa fa-history"></i>
    <span class="cardHeaderHeading"> Enrolled Merchants </span>
    <span class="pull-right panelHeaderHeading"
      >({{ shipMerchantArray.length }} Merchants)</span
    >
  </div>
  <table class="table table-striped table-bordered" *ngIf="shipMerchantArray">
    <thead class="tableheading">
      <tr>
        <th class="text-center transactionHistHeader">MERCHANT NAME</th>
        <th class="text-center transactionHistHeader">TYPE</th>
        <th class="text-center transactionHistHeader">SETTLEMENT</th>
        <th class="text-center transactionHistHeader">FREQUENCY</th>
      </tr>
    </thead>
    <tbody style="background-color: #ffffff;">
      <tr *ngIf="shipMerchantArray.length == 0">
        <td align="center" colspan="7" style="height: 150px;">
          No merchants found.
        </td>
      </tr>
      <tr *ngFor="let merchant of shipMerchantArray">
        <td
          class="text-left transactionHistText"
          *ngIf="hasEntitlement('SHIPS_MERCHANTS_LINK')"
        >
          <a class="transactionHistText" (click)="gotoMerchantsTab(merchant)">{{
            merchant.descriptionLong
          }}</a>
        </td>
        <td
          class="text-center transactionHistText"
          [hidden]="hasEntitlement('SHIPS_MERCHANTS_LINK')"
        >
          {{ merchant.descriptionLong }}
        </td>
        <td class="text-center transactionHistText">
          {{ merchant.merchantType }}
        </td>
        <td class="text-center transactionHistText">
          {{ merchant.autoSettleType }}
        </td>
        <td class="text-center transactionHistText">
          {{ merchant.autoSettleSchedule }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
